import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';

const resources = {
  en: {
    translation: en,
  },
};

const languageDetector = {
  type: 'languageDetector',
  async: true,
  detect: cb => cb('en'),
  init: () => {},
  cacheUserLanguage: () => {},
};

i18n
  .use(initReactI18next)
  .use(languageDetector)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    debug: false,
    keySeparator: '.',
    resources,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export {i18n};

function isHTML(str) {
  var doc = new DOMParser().parseFromString(str, "text/html");
  return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
}

export function t(code, stringToReplace, stringBisToReplace) {
  var _txt = i18n.t(code);
  //var _txt = _i18n[code];
  if (typeof stringToReplace !== 'undefined') {
    _txt = _txt.replace('%1', stringToReplace);
  }
  if (typeof stringBisToReplace !== 'undefined') {
    _txt = _txt.replace('%2', stringBisToReplace);
  }
  return _txt;
}

export function thtml(code) {
  return {__html: code}
}
